import ApplicationController from './application_controller.js'
import { Modal } from 'flowbite'
import { setUrl } from '../utils/url_helpers'

export default class extends ApplicationController {
  static targets = ['modal']
  static values = {
    initialUrl: String
  }

  getModalsOnPage() {
    // modalTargets will only get targets for one modal controller instance
    return document.querySelectorAll('[data-modal-target="modal"]')
  }

  getBackdropsOnPage() {
    return document.querySelectorAll('[modal-backdrop=""]')
  }

  // set z index of this modal higher than existing modals
  setModalZIndex() {
    const startZIndex = 40
    const modals = this.getModalsOnPage()
    this.modalTarget.style.zIndex = startZIndex + modals.length * 10
  }

  // move last backdrop to before the first
  moveLastBackdrop() {
    const backdrops = this.getBackdropsOnPage()
    if (backdrops.length > 1) {
      const firstBackdrop = backdrops[0]
      const lastBackdrop = backdrops[backdrops.length - 1]
      const parent = lastBackdrop.parentNode
      parent.insertBefore(lastBackdrop, firstBackdrop)
    }
  }

  // keep body scroll hidden if modals exist
  handleBodyScroll() {
    const modals = this.getModalsOnPage()
    if (modals.length > 1) {
      document.body.classList.add('overflow-hidden')
    }
  }

  close() {
    this.modal.hide()
  }

  connect() {
    this.initialUrlValue = window.location.href
    this.modal = new Modal(this.modalTarget, {
      placement: 'center',
      backdropClasses: 'modal-backdrop bg-gray-900/50 fixed inset-0',
      onShow: (modal) => {
        this.setModalZIndex()
        // set z index of backdrop slightly lower than the modal's
        modal._backdropEl.style.zIndex = (
          this.modalTarget.style.zIndex - 5
        ).toString()
        this.moveLastBackdrop()
      },
      onHide: () => {
        this.handleBodyScroll()
        this.element.remove()
      }
    })
    this.modal.show()
  }

  disconnect() {
    setUrl(this.initialUrlValue)
  }
}
